import { BaseController } from '~/utils/base-controller';
import APIV5 from '~/models/api';
import { createKTableWidget } from '~/pages/dashboard/models/widget';

export default class KtableWidgetController extends BaseController {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor($injector, $rootScope) {
		super($injector);

		this.shouldShowRightSection = false;

		this.$rootScope = $rootScope;
	}

	/**
	 *
	 * @param {boolean} state
	 */
	highlightSelectedLine(state) {
		this.$timeout(async () => {
			const table = this.widget.reference;

			// Deselect all
			table.deselectRow();

			if (state === true) {
				const rows = table.getRows().filter(r => {
					const data = r.getData();
					return data.root.kid === this.selected;
				});
				for (const row of rows) {
					row.select();
				}
			}
		});
	}

	async reloadRightWidget() {
		this.error = null;
		this.widgetsRight = null;

		/** @type {import('@knitiv/api-client-javascript').QueryBuilder<'subwidget'>} */
		const subrequestBuilder = APIV5.instance.createQueryBuilder();
		subrequestBuilder
			.select(s => s
				.addColumn(c => c
					.as('subwidget')
					.withTarget('K_NODE;WIDGET'),
				),
			)
			.from(f => f
				.addElement('K_NODE;WIDGET'),
			)
			.where(w => w
				.addRule(r => r
					.equalKid('K_NODE;WIDGETACTION', this.action)
					.withPath(p => p
						.flowUp('K_NODE;WIDGETACTION'),
					),
				),
			);

		// eslint-disable-next-line unicorn/no-await-expression-member
		const lines = (await subrequestBuilder.fetchAll()).resolved();
		const subWidget = lines.rows[0].subwidget[0];

		const widgetRight = await createKTableWidget(subWidget.kid, {
			$timeout: this.$timeout,
			$location: this.$location,
			$injector: this.$injector,
			$compile: this.$compile,
			$rootScope: this.$rootScope,
		});

		const widgetLink = `
				<a target="_blank" href="/query?kid=${widgetRight.queryNode.kid}">
					${widgetRight.queryNode.name}
				</a>
			`;

		const variables = widgetRight.query.variable;
		if (variables) {
			const variable = variables.find(v => v.id === 'parent');
			if (!variable) {
				this.error = this.$sce.trustAsHtml(`
						<span>Aucune variable <b>parent</b> trouvée dans la requete ${widgetLink}</span>
					`);
			}
			else if (variable.isa === this.widget.query.from[0].node) {
				widgetRight.variables = {
					[variables[0].id]: [
						{
							kid: this.selected,
						},
					],
				};
			}
			else {
				this.error = this.$sce.trustAsHtml(
					`<span>Le type de la variable <b>parent</b>
						est incompatible avec le type de la requete parente
						(${variable.isa} / ${this.widget.query.from[0].node})</span>`,
				);
			}
		}
		else {
			this.error = this.$sce.trustAsHtml(`
					<span>Aucune variables trouvée dans la requete ${widgetLink}</span>
				`);
		}

		if (widgetRight?.tableOptions) {
			widgetRight.tableOptions.rowClickMenu = false;
		}

		this.$timeout(() => {
			this.widgetsRight = widgetRight;
		});
	}

	closeSubrequest() {
		this.selected = undefined;
	}

	$onInit() {
		this.widget.tableOptions.widget = this.widget.options;

		this.$rootScope.$watch(() => this.selected, () => {
			if (this.selected) {
				this.highlightSelectedLine(true);
				this.reloadRightWidget();

				this.shouldShowRightSection = true;
			}
			else {
				this.highlightSelectedLine(false);

				this.shouldShowRightSection = false;
			}
		});

		this.$rootScope.$on('widget.subrequest', (event, arguments_) => {
			// if not from the same widget
			if (arguments_.widget !== this.widget.kid) {
				return;
			}

			this.action = arguments_.action;
			this.item = arguments_.root;

			this.selected = arguments_.root;
		});
	}
}
